import { useEffect, useState } from 'react';
import type { BookingPageBlock } from './types';

// Admin live preview: /embed?preview=1 inside the admin's own page receives
// the draft booking_page block over postMessage (same origin only).
export function useAdminPreview(embedded: boolean, search: string, loaded: boolean): BookingPageBlock | null {
  const previewMode = embedded && new URLSearchParams(search).get('preview') === '1' && window.parent !== window;
  const [previewBlock, setPreviewBlock] = useState<BookingPageBlock | null>(null);
  useEffect(() => {
    if (!previewMode) return;
    const onMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin || event.data?.type !== 'sloty:preview') return;
      setPreviewBlock(event.data.booking_page as BookingPageBlock);
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [previewMode]);
  useEffect(() => {
    if (previewMode && loaded) window.parent.postMessage({ type: 'sloty:preview-ready' }, window.location.origin);
  }, [previewMode, loaded]);
  return previewBlock;
}
